import { map } from 'lodash';
import { withProps } from 'recompose';

import ContentLinks from './ContentLinks';

export const enhance = withProps(
	({ links }) => ({
		columns: 3,
		links: map(links, ({ city, uri }) => ({
			label: city,
			segmentLabel: 'city',
			segmentProperties: {
				value: city
			},
			uri: `/${uri}`
		}))
	})
);

export default enhance(ContentLinks);
